export enum Consts {
  SHOULD_BE_CLOSED_COOKIE = 'outdatedBrowserClosed',
}
